import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=6f4d039d"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4d039d')) {
      api.createRecord('6f4d039d', component.options)
    } else {
      api.reload('6f4d039d', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=6f4d039d", function () {
      api.rerender('6f4d039d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/conversation-dialog/dialog.vue"
export default component.exports